import locationService from '../../../../services/supplier/location'

export default {
    data() {
        return {
            item: {
                location_id: null,
                idn: null,
                location_name: null,
                address1: null,
                address2: null,
                notisphere_id: null,
                city: null,
                state: null,
                zip_code: null
            },
            formType: 'INSERT',
            labelName: {
                location_id: 'Location Id',
                idn: 'IDN/Hospital Name',
                notisphere_id: 'Notisphere ID',
                location_name: 'Location Name',
                address1: 'Address 1',
                address2: 'Address 2',
                city: 'City',
                state: 'State',
                zip_code: 'Zip'
            },
        }
    },
    computed: {
        form(){
            if(this.formType == 'INSERT'){
                return {
                    title: 'New Location',
                    isDisabled: false
                }
            }
            if(this.formType == 'UPDATE'){
                return {
                    title: 'Update Location',
                    isDisabled: true
                }
            }
        }
    },
    methods: {
        forceRerenderInsert() {
            this.formType = 'INSERT'
            this.$refs.modal.show()
        },
        forceRerenderUpdate(location_id) {
            this.formType = 'UPDATE'
            this.getLocation(location_id)
        },
        async save() {
            var isValid = await this.$refs['observer'].validate()
            if(isValid && this.formType == 'INSERT') {
                this.createLocation()
            }
            if(isValid && this.formType == 'UPDATE'){
                this.updateLocation()
            }
        },
        updateLocation() {
            locationService.updateLocation(this.item).then(resp =>{
                if (!resp.error){
                    this.$emit('onCompleted', 'UPDATE')
                    this.$refs.modal.hide()
                }
            })
        },
        createLocation() {
            locationService.createLocation(this.item).then(resp =>{
                if (!resp.error){
                    this.$emit('onCompleted', 'INSERT')
                    this.$refs.modal.hide()
                }
            })
        },
        getLocation(location_id) {
            locationService.getLocation(location_id).then(resp =>{
                if (!resp.error){
                    this.item = resp.data.d
                    this.$nextTick(()=>{
                        this.$refs.modal.show()
                    })
                }
            })
        }
    }
}